var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24863 20.2117C9.36933 20.0885 9.53528 20.0167 9.71129 20.0167H25.6731C25.9648 20.0167 26.1106 20.376 25.9044 20.5864L22.7513 23.8049C22.6306 23.9281 22.4646 24 22.2886 24H6.32683C6.03516 24 5.88932 23.6407 6.0955 23.4302L9.24863 20.2117Z",
    fill: "url(#paint0_linear_623_801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24853 8.19506C9.37425 8.07186 9.5402 8 9.71119 8H25.673C25.9646 8 26.1105 8.35932 25.9043 8.56978L22.7512 11.7883C22.6305 11.9115 22.4645 11.9833 22.2885 11.9833H6.32673C6.03505 11.9833 5.88921 11.624 6.0954 11.4135L9.24853 8.19506Z",
    fill: "url(#paint1_linear_623_801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7513 14.1649C22.6306 14.0417 22.4646 13.9698 22.2886 13.9698H6.32683C6.03516 13.9698 5.88932 14.3292 6.0955 14.5396L9.24863 17.7581C9.36933 17.8813 9.53528 17.9532 9.71129 17.9532H25.6731C25.9648 17.9532 26.1106 17.5938 25.9044 17.3834L22.7513 14.1649Z",
    fill: "url(#paint2_linear_623_801)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_801",
    x1: 24.1483,
    y1: 6.07735,
    x2: 12.7411,
    y2: 27.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_801",
    x1: 19.3179,
    y1: 3.5033,
    x2: 7.91074,
    y2: 24.9089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_801",
    x1: 21.7177,
    y1: 4.78214,
    x2: 10.3106,
    y2: 26.1878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white",
    transform: "translate(6 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SOL.da5a92746ae1956288ce9645cc805b6c.svg";